import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogDescription,
} from "@/components/ui/dialog";
import ContactForm from "@/components/ContactForm";

export default function EnquiryDialog({ open, onOpenChange, product }) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent
        className="max-w-2xl bg-white"
        data-testid="enquiry-dialog"
      >
        <DialogHeader>
          <DialogTitle className="font-display text-2xl text-[#0B2545]">
            Enquire about {product?.name}
          </DialogTitle>
          <DialogDescription className="text-slate-600">
            Share your requirement and our team will respond within 24 hours
            with pricing, pack options and export documentation.
          </DialogDescription>
        </DialogHeader>
        <ContactForm
          defaultType="product"
          defaultSubject={`Product Enquiry: ${product?.name || ""}`}
          defaultMessage={`I'd like more information about ${product?.name}. Please share datasheet, pack sizes and pricing.`}
          productName={product?.name}
          compact
          testIdPrefix="product-enquiry"
        />
      </DialogContent>
    </Dialog>
  );
}
